/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelHIcon32Regular = forwardRef('ArrowParallelHIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M19.512 3.145a1 1 0 0 1 1.414-1.415l5.237 5.237a2.875 2.875 0 0 1 0 4.066l-5.237 5.237a1 1 0 0 1-1.414-1.415L24.367 10H6a1 1 0 1 1 0-2h18.367l-4.855-4.855Z" }),
        React.createElement("path", { d: "M12.489 17.145a1 1 0 0 0-1.415-1.415l-5.236 5.237a2.875 2.875 0 0 0 0 4.066l5.236 5.237a1 1 0 0 0 1.415-1.415L7.633 24H26a1 1 0 1 0 0-2H7.633l4.856-4.855Z" })));
});
